import { render } from "./PrintInstallmentTableDesign4.vue?vue&type=template&id=f27f19ba&scoped=true"
import script from "./PrintInstallmentTableDesign4.vue?vue&type=script&lang=js"
export * from "./PrintInstallmentTableDesign4.vue?vue&type=script&lang=js"

import "./PrintInstallmentTableDesign4.vue?vue&type=style&index=0&id=f27f19ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27f19ba"]])

export default __exports__